import React, { createContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen to auth state changes
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const token = await currentUser.getIdToken(true);
          setUser({
            uid: currentUser.uid,
            email: currentUser.email,
            displayName: currentUser.displayName,
            token, // Include token for future use
          });
          localStorage.setItem(
            "user",
            JSON.stringify({
              uid: currentUser.uid,
              email: currentUser.email,
              displayName: currentUser.displayName,
            }),
          ); // Persist basic user info in localStorage
        } catch (error) {
          console.error("Error getting token:", error);
        }
      } else {
        setUser(null);
        localStorage.removeItem("user"); // Clear localStorage on logout
      }
      setLoading(false);
    });

    return () => unsubscribe(); // Clean up listener on unmount
  }, []);

  // Function to manually refresh token
  const refreshToken = async () => {
    if (auth.currentUser) {
      try {
        const token = await auth.currentUser.getIdToken(true);
        setUser((prev) => ({
          ...prev,
          token,
        }));
        return token;
      } catch (error) {
        console.error("Error refreshing token:", error);
        return null;
      }
    }
    return null;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, refreshToken }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
